module.exports = __webpack_public_path__ + "img/ostruziny-6.cd4a5792.png";